import React from 'react';
import './Gallery.css';

interface Painting {
  src: string;
  title: string;
  price: string;
  dimensions: string;
  availability: string;
}
interface GalleryProps {
  paintings: Painting[];
}

const Gallery: React.FC<GalleryProps> = ({ paintings }) => {

  const handleOfferClick = async (painting: Painting) => {
    const timestamp = new Date().toISOString();
    
    console.log(`User clicked "Cere ofertă" for: src=${painting.src}, Title=${painting.title}, Timestamp=${timestamp}`);

    // Send request to Vercel (self-call to trigger logs)
    await fetch('/api/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: painting.src, title: painting.title, timestamp }),
    });
  };

  return (
    <div className="gallery-container">
      {paintings.map((painting, index) => (
        <div key={index} className="painting-card">
          <img src={painting.src} alt={painting.title} className="painting-image" />

          <div className="painting-info">
            <div className="painting-title">{painting.title}</div>
            <div className="painting-dimensions">{painting.dimensions}</div>
            <div className="painting-qoute">
              <a href="/contact" onClick={() => handleOfferClick(painting)}>
                <button className="contact-button">Cere ofertă</button>
              </a>
            </div>
            {/* <div className="painting-price">{painting.price} lei</div> */}
            <div className="painting-price">{painting.price}</div>
          </div>

          <div className="painting-availability">
            {painting.availability}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Gallery;
